import React, { Component } from 'react';
import { Text, View, ActivityIndicator, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE } from '../../constants/styles';
import OPComponent from './op_component';
import I18n from '../../I18n';

export const PERMISSION_DENIED_STATUS = 'PERMISSION_DENIED_STATUS';
export const PERMISSION_GRANTED_STATUS = 'PERMISSION_GRANTED_STATUS';
export default class PermissionRestrictedComponent extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      permissionStatus: PERMISSION_GRANTED_STATUS,
    };
  }

  requestPermission() {
    Promise.resolve();
  }

  componentDidMount() {
    Promise.resolve();
  }

  renderActivityIndicator() {
    return (
      <ActivityIndicator
        style={styles.activityIndicator}
        animating={true}
        size="large"
        color="gray"
      />
    );
  }

  openSettings = () => {
    openSettings().catch(() => console.warn('cannot open settings'));
  };

  renderDeniedView() {
    return (
      <View style={[styles.container, styles.containerWithPadding]}>
        <Text style={styles.accessDeniedText}>{I18n.t('components.noPermissionsText')}</Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  accessDeniedText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.regular,
    textAlign: 'center',
    margin: 20,
  },
  goToSettingsText: {
    marginTop: 10,
    ...FONT.semibold,
    fontSize: FONT_SIZE.large,
    color: COLOR.callToAction,
    textAlign: 'center',
    textDecorationLine: 'underline',
  },
  activityIndicator: {
    margin: 20,
  },
});
